import _ from 'lodash'

/**
 * Converts an amount in centimes to credits (1 credit = 100 centimes)
 * @param  {int} centimes
 */
export const centimes_to_credits = (centimes) => {
  return _.ceil(centimes/100, 2)
}
